module.exports = __webpack_public_path__ + "images/content/easily_track_status_of_deals.gif";